import React, { Component } from "react";
import PreferencesForm from "./components/PreferencesForm";
import { loadPreferences, updatePreferences } from "./actions";
import { connect } from "react-redux";
import { connectSaga } from "../../util/hoc/connectSaga";
import { watchPreferencesRequests } from "./sagas";
import "./index.css";

class PreferencePage extends Component {
  componentDidMount() {
    this.props.actions.loadPreferences();
  }
  render() {
    const { isLoading, actions } = this.props;
    return (
      <div className="preferences page">
        <h1>Email Preferences:</h1>
        <p className="subtitle">Here you can manage how you want to get in touch with Casemasters and hear from us:</p>
        <PreferencesForm isLoading={isLoading} onSubmit={actions.updatePreferences} />
      </div>
    );
  }
}
const mapStateToProps = state => ({
  isLoading: !(state.form.preferencesForm && state.form.preferencesForm.initial),
});

const mapDispatchToProps = dispatch => ({
  actions: {
    loadPreferences: (...props) => dispatch(loadPreferences(...props)),
    updatePreferences: (...props) => dispatch(updatePreferences(...props)),
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(connectSaga(PreferencePage, watchPreferencesRequests));



// WEBPACK FOOTER //
// ./src/scenes/PreferencesPage/index.js